export default __webpack_public_path__ + "locales/en/People.json?hash=6a6905d77872a6c3258ed513835420de";